import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Map} from 'immutable';
import * as DisplayMode from 'constants/DisplayMode';
import {setDisplayMode as setDisplayModeAction} from 'actions/creators/SetDisplayMode';

import {LocalizedDocumentMeta} from 'shared/LocalizedDocumentMeta.jsx';

import * as SortMode from '../SortMode';

import Grid from './Grid.jsx';
import Menu from './FilterMatchesMenu.jsx';
import { getMetadata } from '../../../../shared/metadata/metadata.js';

const messages = defineMessages({
    title: {
        id: 'timetable.title',
        defaultMessage: 'Календарь лайв событий'
    },
    timeFilterTitle: {
        id: 'timetable.time_filter',
        defaultMessage: 'Все события'
    },
    sortByTime: {
        id: 'timetable.sort_by_time',
        defaultMessage: 'Сортировать по времени'
    },
    sortByLeague: {
        id: 'timetable.sort_by_league',
        defaultMessage: 'Сортировать по виду соревнования'
    },
    pageTitle: {
        id: 'pages.timetable.title',
        defaultMessage: 'Спортивные трансляции. Расписание предстоящих матчей.'
    },
    pageDescription: {
        id: 'pages.timetable.description',
        defaultMessage: 'Список онлайн трансляций спортивных событий, для которых возможны букмекерские ставки.'
    },
    no_filter: {
        id: 'timetable.matches_filter_menu.no_filter',
        defaultMessage: 'Все события'
    },
    one_hour: {
        id: 'timetable.matches_filter_menu.one_hour',
        defaultMessage: 'Ближайщий час'
    },
    two_hours: {
        id: 'timetable.matches_filter_menu.two_hours',
        defaultMessage: 'Ближайщие 2 часа'
    },
    four_hours: {
        id: 'timetable.matches_filter_menu.four_hours',
        defaultMessage: 'Ближайщие 4 часа'
    },
    six_hours: {
        id: 'timetable.matches_filter_menu.six_hours',
        defaultMessage: 'Ближайщие 6 часов'
    },
    twelve_hours: {
        id: 'timetable.matches_filter_menu.twelve_hours',
        defaultMessage: 'Ближайщие 12 часов'
    },
    one_day: {
        id: 'timetable.matches_filter_menu.one_day',
        defaultMessage: 'Ближайщий день'
    },
    two_days: {
        id: 'timetable.matches_filter_menu.two_days',
        defaultMessage: 'Ближайщие 2 дня'
    }
});

class Timetable extends React.Component {
    static propTypes = {
        sports: React.PropTypes.instanceOf(Map).isRequired,
        leagues: React.PropTypes.instanceOf(Map).isRequired,
        matches: React.PropTypes.instanceOf(Map).isRequired,
        setDisplayModeAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            filter: null,
            filterMenuVisible: false,
            sortMode: SortMode.SORT_BY_LEAGUE
        };

        this._handleWidthAdjust = this._handleWidthAdjust.bind(this);
        this._handleFilterClick = this._handleFilterClick.bind(this);
        this._handleFilterMatches = this._handleFilterMatches.bind(this);
        this._handleMenuClosing = this._handleMenuClosing.bind(this);
        this._handleSortClick = this._handleSortClick.bind(this);
    }

    componentWillMount() {
        this.props.setDisplayModeAction({type: DisplayMode.TIMETABLE});
    }

    componentDidMount() {
        this._widthAdjustmentInterval = window.setInterval(this._handleWidthAdjust, 500);
    }

    componentWillUnmount() {
        if (this._widthAdjustmentInterval) {
            window.clearInterval(this._widthAdjustmentInterval);
        }
    }

    _handleWidthAdjust() {
        const contentWidth = this.refs.content.offsetWidth;
        const titleWidth = this.refs.title.offsetWidth;

        if (contentWidth !== titleWidth) {
            this.refs.title.style.width = contentWidth + 'px';
        }
    }

    _handleFilterClick(hours) {
        const state = this.state;

        this.setState({
            ...state,
            filter: hours
        });
    }

    _handleFilterMatches(e) {
        e.preventDefault();

        const state = this.state;

        this.setState({
            ...state,
            filterMenuVisible: !state.filterMenuVisible
        });
    }

    _handleMenuClosing() {
        const state = this.state;

        this.setState({
            ...state,
            filterMenuVisible: false
        });
    }

    _handleSortClick(e) {
        e.preventDefault();

        const currentSortMode = this.state.sortMode;

        const sortMode = (currentSortMode === SortMode.SORT_BY_TIME) ? SortMode.SORT_BY_LEAGUE : SortMode.SORT_BY_TIME;

        const state = this.state;

        this.setState({
            ...state,
            sortMode
        });
    }

    static _renderDropdownTitle(hours) {
        let msg;

        if (hours === 1) {
            msg = (<FormattedMessage {...messages.one_hour} />);
        } else if (hours === 2) {
            msg = (<FormattedMessage {...messages.two_hours} />);
        } else if (hours === 4) {
            msg = (<FormattedMessage {...messages.four_hours} />);
        } else if (hours === 6) {
            msg = (<FormattedMessage {...messages.six_hours} />);
        } else if (hours === 12) {
            msg = (<FormattedMessage {...messages.twelve_hours} />);
        } else if (hours === 24) {
            msg = (<FormattedMessage {...messages.one_day} />);
        } else if (hours === 48) {
            msg = (<FormattedMessage {...messages.two_days} />);
        } else {
            msg = (<FormattedMessage {...messages.no_filter} />);
        }

        return msg;
    }

    render() {
        const {sports, leagues, matches, countryCode} = this.props;

        const {filterMenuVisible, sortMode, filter} = this.state;

        const menuProps = {
            onFilterClick: this._handleFilterClick,
            onClosing: this._handleMenuClosing,
            activeElement: filter
        };

        const sortTitle = sortMode === SortMode.SORT_BY_TIME ? messages.sortByLeague : messages.sortByTime;

        const gridProps = {
            sports,
            leagues,
            matches,
            sortMode,
            filter
        };

        const metadata = getMetadata(countryCode);

        return (
            <div id="live-content">
                <LocalizedDocumentMeta title={messages.pageTitle} description={messages.pageDescription} keywords={metadata.keywords} />
                <div className="live-titles scroll--top schedule" ref="title">
                    <div className="table main-heading">
                        <div className="row">
                            <span className="cell main">
                                <div className="cell-main__title">
                                    <FormattedMessage {...messages.title} />
                                </div>
                                <div className="pull-right">
                                    <div className="schedule--events">
                                        <a href="#" className="dropdown--toggle" onClick={this._handleFilterMatches}>
                                            {Timetable._renderDropdownTitle(filter)}
                                        </a>
                                        {filterMenuVisible && <Menu {...menuProps}/>}
                                    </div>
                                    <a href="#" className="schedule--sort" onClick={this._handleSortClick}>
                                        <FormattedMessage {...sortTitle} />
                                    </a>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="scroll--wrapper">
                    <div className="scroll--wrapper__inner" ref="content">
                        <Grid {...gridProps}/>
                    </div>
                </div>
            </div>
        );
    }
}

function select(state) {
    const countryCode = state.application.get('countryCode');
    const timetable = state.application.get('timetable');

    const sports = timetable.get('sports');
    const leagues = timetable.get('leagues');
    const matches = timetable.get('matches');

    return {
        sports,
        leagues,
        matches,
        countryCode,
    };
}

export default connect(select, {setDisplayModeAction})(Timetable);



// WEBPACK FOOTER //
// ./js/sport-betting/components/Timetable/components/Timetable.jsx